module.exports = "/_next/static/images/Hero@2x-dd64214d9d4ccd528ff4de28c8e94aae.png";